import type { ReactNode } from 'react';

export const symbol_low_priority: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-494q0 88 62.5 146.5T352-289l-46-47q-8-9-8-21t9-21q9-9 21-9t21 9l94 97q8 9 8.5 21t-8.5 21l-97 98q-9 9-21 9t-21-9q-8-8-8.5-20.5T303-183l44-46q-110 0-188.5-76.5T80-494q0-109 74.5-187.5T336-760h122q13 0 21.5 8.5T488-730q0 13-8.5 21.5T458-700H336q-82 0-139 60.5T140-494Zm462 205h248q13 0 21.5 8.5T880-259q0 13-8.5 21.5T850-229H602q-13 0-21.5-8.5T572-259q0-13 8.5-21.5T602-289Zm1-236h247q13 0 21.5 8.5T880-495q0 13-8.5 22t-21.5 9H602q-13 0-21.5-9t-8.5-22q0-13 9-21.5t22-8.5Zm-25-235h272q13 0 21.5 8.5T880-730q0 13-8.5 21.5T850-700H578q-13 0-21.5-8.5T548-730q0-13 8.5-21.5T578-760Z"
		/>
	</svg>
);
